'use strict';

/**
 * Base class for a page view
 *
 * @category   Model
 * @module     collection
 * @copyright  Copyright (c) 2014, COLIDO (http://www.colido.net)
 * @author     Stefan Rueschenberg <sr@humans.am>
 * @author     Jonas Girnatis <dermusterknabe@gmail.com>
 */

var LayoutView = require('base/Colido.LayoutView');
var SearchView = require('modules/global/views/layout/search');

var BaseLayout = LayoutView.extend({
    regions: {
        searchRegion: '#search',
    },

    /**
     * Should the view include search?
     * @type {boolean}
     */
    provideSearch: true,

    initialize: function(options) {
        LayoutView.prototype.initialize.apply(this, arguments);

        // Add region for search?
        if (this.getOption('provideSearch')) {
            this.addRegion('searchRegion', '#search');
        }

        // Extend ui
        this.ui = this.ui || {};
        _.extend(this.ui, {
            'closeShowroom': '[data-action="close-showroom"]',
            'viewOption': 'input[name="viewShowroom"]',
        });

        // Extend events
        this.events = this.events || {};
        _.extend(this.events, {
            'click @ui.closeShowroom': 'closeShowroom',
            'change @ui.viewOption': 'changeCurrentView',
        });
    },

    onRender: function() {
        // Render search?
        if (this.getOption('provideSearch') &&
            this.$('header').length  &&
            !this.$el.parents('#extra-content').length
        ) {
            if (!this.$('#search').length) {
                var $search = $('<div>').attr({id: 'search'}).addClass('search-header');

                if (this.$('header .header-part-view').length) {
                    this.$('header .header-part-view').append($search);
                } else {
                    this.$('header').append($search);
                }
            }

            // Append region
            if (typeof App === 'object' && this.$('#search').length) {
                this.searchRegion.show(new SearchView({
                    // model: App.CollectionModule.controller.params,
                    model: this.getOption('settingsModel'),
                    clearOnInit: true,
                }));
            }
        }
    },

    /**
     * Closes the showroom view
     */
    closeShowroom: function() {
        this.regionManager.get('objectsRegion').currentView.triggerMethod('close:showroom');
    },

    /**
     * Changes the showroom view
     * @param {object} event The change event
     */
    changeCurrentView: function(event) {
        this.regionManager.get('objectsRegion').currentView.triggerMethod('change:showroom:view', event);
    },

    /**
     * Is triggered from childview, when list view changed to showroom
     * @param {string} viewMode The new viewmode [showroom-grid]
     */
    onSwitchedToShowroom: function(viewMode) {
        this.$('input[value="' + viewMode + '"]').prop('checked', true);
        if ($('header').hasClass('is-editmode')) {
            $('header').removeClass('is-editmode');
        }
    },
});

module.exports = BaseLayout;